import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KennethMustDie} from "../KennethMustDie";
import {KMDPreIntro} from "./KMDPreIntro";

export class KMDIntroPlugin extends NolimitGameIntroPlugin {

    private _entryView: KMDPreIntro;

    public async getReady(): Promise<NolimitPlugin> {
        await super.getReady();

        if (this.showEntryPage()) {
            this._entryView = new KMDPreIntro();
            this._entryView.show();
            this._view.slideShow.navToIndex(1);
            this._view.slideShow.stop();
        }

        return Promise.resolve(this);
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        if (this.showEntryPage()) {
            NolimitApplication.getLayerByName("INTRO")!.interactiveChildren = false;
            await this._entryView.complete();

            this._view.slideShow.start();
            NolimitApplication.getLayerByName("INTRO")!.interactiveChildren = true;
        }
        return super.getReadyToStart();
    }

    private showEntryPage(): boolean {
        // #520
        if (KennethMustDie.model.initData.isRestoreState || KennethMustDie.apiPlugin.gameClientConfiguration.explicitContentWarning) {
            return false;
        }

        return !KennethMustDie.apiPlugin.isReplay;
    }
}